/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BatchResourceValidationResult } from '../models/BatchResourceValidationResult';

export class BatchValidateResourceConfigurationResponse {
  /**
  * Validation results for each unique resource.
  */
  'results': Array<BatchResourceValidationResult>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "results",
      "baseName": "results",
      "type": "Array<BatchResourceValidationResult>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BatchValidateResourceConfigurationResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

